import TextareaAutogrow from "stimulus-textarea-autogrow"

// This controller uses the stimulus-textarea-autogrow package to automatically grow a textarea element.
export default class extends TextareaAutogrow {
  static values = {
    enablePlaceholderResize: Boolean
  }

  connect() {
    super.connect()

    if (this.enablePlaceholderResizeValue) {
      this.setupVisibilityObserver()
    }
  }

  disconnect() {
    this.cleanupVisibilityObservers()
    super.disconnect()
  }

  isVisible() {
    return this.element.offsetWidth > 0 && this.element.offsetHeight > 0
  }

  setupVisibilityObserver() {
    if (window.ResizeObserver) {
      this.resizeObserver = new ResizeObserver((entries) => {
        for (let entry of entries) {
          if (entry.contentRect.width > 0 && entry.contentRect.height > 0) {
            this.onBecomeVisible()
            break
          }
        }
      })
      this.resizeObserver.observe(this.element)
    }
  }

  onBecomeVisible() {
    this.cleanupVisibilityObservers()
    this.autogrow()
  }

  cleanupVisibilityObservers() {
    if (this.resizeObserver) {
      this.resizeObserver.disconnect()
      this.resizeObserver = null
    }

    if (this.mutationObserver) {
      this.mutationObserver.disconnect()
      this.mutationObserver = null
    }
  }

  autogrow() {
    if (!this.isVisible()) {
      return
    }

    const element = this.element

    if (this.enablePlaceholderResizeValue && !element.value && element.placeholder) {
      this.autogrowWithPlaceholder()
    } else {
      super.autogrow()
    }
  }

  autogrowWithPlaceholder() {
    const element = this.element
    const originalValue = element.value
    const computedStyle = window.getComputedStyle(element)
    const minHeight = parseInt(computedStyle.minHeight)

    // Temporarily set placeholder as value to measure proper height
    element.value = element.placeholder
    element.style.height = "auto"

    const measuredHeight = element.scrollHeight
    const targetHeight = Math.max(measuredHeight, minHeight)

    // Restore original value and apply the calculated height
    element.value = originalValue
    element.style.height = `${targetHeight}px`
  }
}
